import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable no-restricted-imports */
import UserLoginButtonContainer from 'dpl/UserAuth/containers/UserLoginButtonContainer';
import Icon from 'dpl/common/components/Icon';
/* eslint-enable no-restricted-imports */

/** @param {any} props */
export default function EmailUnavailableErrorMessage({ onLoginClick = null }) {
  return (
    <div className="flex">
      <Icon name="fetch-union" className="red mr1" width="16px" height="16px" />
      <span className="f1 f2-sm default-color">
        This email is already connected to an account.&nbsp;
        <UserLoginButtonContainer
          className="underline fw-medium"
          onClick={onLoginClick}
        />
      </span>
    </div>
  );
}

EmailUnavailableErrorMessage.propTypes = {
  onLoginClick: PropTypes.func
};
